import styles from "./styles.module.less";

interface IProps {
  zIndex?: number;
  className?: string;
}

const FixedWidget: React.FC<IProps> = ({ children, zIndex = 9999, className }) => {
  return (
    <div className={`${styles.fixedWidget} ${className}`} style={{ zIndex }}>
      {children}
    </div>
  );
};

export default FixedWidget;
